package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.model.GameEvent
import fr.manyverse.app.domain.repository.GameEventRepository
import kotlin.time.Instant

class GetTableEventsUseCase(
    private val gameEventRepository: GameEventRepository
) {
    suspend operator fun invoke(
        tableId: String,
        limit: Int,
        offset: Int,
        eventTypes: List<EventType> = emptyList(),
        since: Instant? = null
    ): Result<List<GameEvent>> {
        return gameEventRepository.getTableEvents(
            tableId = tableId,
            limit = limit,
            offset = offset,
            eventTypes = eventTypes,
            since = since
        )
    }
}
